import script from "./RenderPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RenderPage.vue?vue&type=script&setup=true&lang=js"

import "./RenderPage.vue?vue&type=style&index=0&id=890e0cce&lang=css"

const __exports__ = script;

export default __exports__